export default {
  uploadTime: 'UploadTime',
  approvalProcess: 'ApprovalProcess',
  onlineEdition: 'OnlineVersion',
  auditEdition: 'AuditEdition',
  developEdition: 'DevelopVersion',
  experienceEdition: 'ExperienceVersion',
  applicationManagement: 'AapplicationManagement',
  developer: 'Developer',
  editionNum: 'VersionNum',
  publisher: 'Publisher',
  publishSubscribe: 'Subscribe',
  attachment: 'Attachment',
  publishTime: 'Time',
  editionPublish: {name: 'Publish', tip: '发布版本后，请联系企业管理员审核，审核通过后企业内成员将使用最新版本'},
  isvEditionPublish: {name: 'Publish', tip: '发布版本后，体验版二维码可供使用人员范围内的成员扫码体验'},
  inTouchEnterpriseManager: {name: 'Contact Manager', tip: '版本发布成功后，还需要企业管理员审核，审核通过后员工才能用上新版本'},
  withdrawEdition: {name: 'Withdraw', tip: '撤回后会中断管理员的审核'},
  disableTip: 'Stopped by manager for reason:',
  applicationManager: 'applicationManager',
  coDevelopers: 'CoDevelopers',
  enterpriseManager: 'EnterpriseManager',
  allStaff: 'AllStaff',
  check: 'Check',
  checkInstruction: 'Set Scope',
  editionInstruction: 'Version Instrument',
  NoInstruction: 'No Version',
  scopeRow: 'scope',
  ok: 'Ok',
  cancel: 'cancel',
  change: 'Modify',
  chineseName: 'chineseName',
  version: 'version',
  previesRes: 'previesRes',
  submitTime: 'submitTime',
  previewFile: 'previewFile',
  preReviewDate: 'preReviewDate',
  auditFileName: 'auditFileName',
  preview: 'preview',
  pass: 'pass',
  rejected: 'rejected',
  preving: 'preving',
  download: 'download',
  contact: 'contact',
  contactEmail: 'contactEmail',
  func: 'func',
  funcTable: 'funcTable',
  safe: 'safe',
  safeTable: 'safeTable',
  UCD: 'UCD',
  UCDTable: 'UCDTable',
  upload: 'upload',
  downloadExcel: 'downloadExcel',
  submit: 'submit'
};
